import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  pagination: {
    position: 'relative',
    display: 'inline-block',
    textAlign: 'center',
    marginTop: '-50px',
    paddingBottom: '32px',
  },
  table: {
    width: '100%',
    objectFit: 'contain',
    height: 'inherit',
  },
  activeFilter: {
    color: '#3560FF',
  },
  tablesContainer: {
    display: 'flex',
    alignItems: 'auto',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    height: '78vh',
    marginTop: '-53px',
  },
  tableLeft: {
    width: '100%',
    objectFit: 'contain',
    height: 'inherit',
  },
}));
